const Footer = () => {
  return (
    <footer>
      <p>© 2026 ProgSense. Lyceum of Alabang.</p>
    </footer>
  );
};

export default Footer;
